import React, { useEffect, useRef, useState } from 'react'
import styles from './styles.module.scss'

import { Form, Table, Footer } from './Components'
import { useFormik } from 'formik'
import { useDispatch, useSelector } from 'react-redux'
import { getData, updateData } from '../../actions/disciplineStructure'
import { DisciplineStructureContext } from '../../utils/context'
import { getDataForUpdate } from '../../utils/disciplineStructure'
import { createNotification } from '../../components/Notifications/Notifications'

// const initialValues = {
//   educationType: 0,
//   year: 0,
//   profile: 0,
//   teacher: 0,
//   discipline: 0
// }
const initialValues = {
  course_type: 0,
  xp_key: 0,
  trp_id: 0,
  mid: 0,
  cid: 0
}

export default function DisciplineStructure({ from }) {

  const dispatch = useDispatch()
  const { data } = useSelector(state => state.discipline_structure)

  const [tableData, setTableData] = useState([])
  const [selectedRow, setSelectedRow] = useState(null)
  const [editParams, setEditParams] = useState(null)
  const [editingRow, setEditingRow] = useState(null)
  const tableAreaRef = useRef(null);

  useEffect(() => {
    if (data?.length) {
      setTableData(data)
      setEditingRow(null)
    }
  }, [data])

  const getTableData = values => {
    const { educationType, year, profile, teacher, discipline } = values
    if (!year || !teacher || !discipline) return;
    const params = { course_type: educationType }
    dispatch(getData(year, teacher, discipline, profile, params))
  }

  const form = useFormik({
    initialValues: initialValues,
    onSubmit: getTableData
  })

  useEffect(() => {
    form.handleSubmit()

  }, [form.values])

  useEffect(() => {
    from && form.setFieldValue('course_type', from)
  }, [from])


  const buttonsBlockRef = useRef(null)

  const editRow = actionType => {
    const newTableData = JSON.parse(JSON.stringify(tableData));
    const { idsList, depth } = editParams
    const editableLevel = idsList.slice(0, -1).reduce((item, index) => item[index]?.children || [], newTableData)
    const index = idsList.at(-1)

    const action = actionType === 'up' ? moveUp : moveDown

    // Вычисляем новый индекс после перемещения
    let newIndex = index
    if (actionType === 'up' && index > 0) {
      newIndex = index - 1
    } else if (actionType === 'down' && index < editableLevel.length - 1) {
      newIndex = index + 1
    } else {
      // Если перемещение невозможно, просто выходим
      return
    }

    action(editableLevel, index)
    setTableData(newTableData);

    // Обновляем selectedRow и editParams с новым индексом
    const newSelectedRow = editableLevel[newIndex]
    const newIdsList = [...idsList.slice(0, -1), newIndex]

    setSelectedRow(newSelectedRow)
    setEditParams({ idsList: newIdsList, depth })
  }

  const deleteRow = () => {
    if (!editParams) return

    const newTableData = JSON.parse(JSON.stringify(tableData))
    const { idsList } = editParams

    if (idsList.length === 1) {
      // Удаление элемента верхнего уровня
      newTableData.splice(idsList[0], 1)
    } else {
      // Удаление вложенного элемента
      const parentLevel = idsList.slice(0, -1).reduce((item, index) => item[index]?.children || [], newTableData)
      const index = idsList.at(-1)
      parentLevel.splice(index, 1)
    }

    setTableData(newTableData)
    setSelectedRow(null)
    setEditParams(null)
  }

  // СОЗДАНИЕ НОВОЙ СТРОКИ - НОВОЙ ПОДСТРОКИ - УДАЛЕНИЕ СТРОКИ - ВВЕХ НА УРОВЕНЬ - ВНИЗ
  // Клиентский id только для React key/выделения строки — на бэкенд не отправляется (см. getDataForUpdate)
  const generateLocalId = () => `local-${Date.now()}-${Math.random().toString(36).slice(2)}`

  const createRow = actionType => {
    const isTopLevel = actionType === 'new'

    if (isTopLevel && !selectedRow) {
      // Создание на верхнем уровне без выбранной строки
      const newRow = {
        _localId: generateLocalId(),
        cid: data[0]?.cid,
        prev_ref: null,
        prev_refs: null,
        level: 0,
        title: '',
        module: 0,
        s_year_id: data[0]?.s_year_id,
        teacher_mid: data[0]?.teacher_mid,
        position: null,
        nr: null,
        hrs: null,
        track_profile_id: 0,
        expected_result: '',
        exercises: null,
        exid: null,
        teacher: data[0]?.teacher || '',
        predmet: '',
        children: [],
        isEditing: true
      }
      setEditingRow({ row: newRow, parentIdsList: null, insertIndex: tableData.length })
      return
    }

    if (!editParams) return

    const { idsList, depth } = editParams

    if (isTopLevel) {
      // Создание на том же уровне (после выбранного элемента)
      const level = selectedRow?.level ?? 0
      const newRow = {
        _localId: generateLocalId(),
        cid: data[0]?.cid,
        prev_ref: null,
        prev_refs: null,
        level,
        title: '',
        module: 0,
        s_year_id: data[0]?.s_year_id,
        teacher_mid: data[0]?.teacher_mid,
        position: null,
        nr: null,
        hrs: null,
        track_profile_id: 0,
        expected_result: '',
        exercises: null,
        exid: null,
        teacher: data[0]?.teacher || '',
        predmet: '',
        children: [],
        isEditing: true
      }
      const parentIdsList = idsList.slice(0, -1)
      const insertIndex = idsList.at(-1) + 1
      setEditingRow({ row: newRow, parentIdsList, insertIndex })
    } else {
      // Создание дочернего элемента
      if (!selectedRow?.oid || selectedRow.oid <= 0) {
        createNotification('warning', 'Сначала сохраните родительский элемент, чтобы добавить дочерний', 'Внимание', 3000)
        return
      }

      const level = (selectedRow?.level ?? 0) + 1
      const newRow = {
        _localId: generateLocalId(),
        cid: data[0]?.cid,
        prev_ref: null,
        prev_refs: null,
        level,
        title: '',
        module: 0,
        s_year_id: data[0]?.s_year_id,
        teacher_mid: data[0]?.teacher_mid,
        position: null,
        nr: null,
        hrs: null,
        track_profile_id: 0,
        expected_result: '',
        exercises: null,
        exid: null,
        teacher: data[0]?.teacher || '',
        predmet: '',
        children: [],
        isEditing: true
      }
      setEditingRow({ row: newRow, parentIdsList: idsList, insertIndex: selectedRow?.children?.length ?? 0 })
    }
  }

  const startEditingRow = (row, idsList, depth) => {
    // Создаем editingRow для редактирования существующего элемента
    const editRow = {
      row: { ...row, isEditing: true },
      parentIdsList: idsList.slice(0, -1),
      insertIndex: idsList.at(-1),
      isEditing: true // Флаг, что это редактирование, а не создание
    }
    setEditingRow(editRow)
    setSelectedRow(null)
  }

  const confirmNewRow = (rowData) => {
    if (!editingRow) return

    const newTableData = JSON.parse(JSON.stringify(tableData))
    const { parentIdsList, insertIndex, isEditing } = editingRow
    const newRow = { ...rowData, isEditing: false }

    if (isEditing) {
      // Редактирование существующего элемента - заменяем
      if (!parentIdsList || parentIdsList.length === 0) {
        // Замена на верхнем уровне
        newTableData[insertIndex] = newRow
      } else {
        // Замена вложенного элемента
        const parent = parentIdsList.reduce((item, index) => {
          if (!item[index].children) item[index].children = []
          return item[index].children
        }, newTableData)
        if (!parent) return
        parent[insertIndex] = newRow
      }
    } else {
      // Создание нового элемента - вставляем
      if (!parentIdsList || parentIdsList.length === 0) {
        // Вставка на верхнем уровне
        newTableData.splice(insertIndex, 0, newRow)
      } else {
        // Вставка в дочерний уровень
        const parent = parentIdsList.reduce((item, index) => {
          if (!item[index].children) item[index].children = []
          return item[index].children
        }, newTableData)
        if (!parent) return
        parent.splice(insertIndex, 0, newRow)
      }
    }

    setTableData(newTableData)
    setEditingRow(null)
    setSelectedRow(null)
  }

  const cancelNewRow = () => {
    setEditingRow(null)
  }

  const updateEditingRow = (field, value) => {
    if (!editingRow) return
    setEditingRow({
      ...editingRow,
      row: { ...editingRow.row, [field]: value }
    })
  }

  const titleEdit = (e) => {
    const newTableData = JSON.parse(JSON.stringify(tableData));
    const { idsList, depth } = editParams
    const editableLevel = idsList.slice(0, -1).reduce((item, index) => item[index]?.children || [], newTableData)
    const index = idsList.at(-1)
    editableLevel[index].title = e.target.innerText
    setTableData(newTableData);
    setSelectedRow(null)
  }

  const moveUp = (editableLevel, index) => {
    if (index === 0) return;
    const temp = editableLevel[index - 1];
    editableLevel[index - 1] = editableLevel[index];
    editableLevel[index] = temp;
  };

  const moveDown = (editableLevel, index) => {
    if (index === editableLevel.length - 1) return;
    const temp = editableLevel[index + 1];
    editableLevel[index + 1] = editableLevel[index];
    editableLevel[index] = temp;
  };

  const saveData = () => {
    const dataForUpdate = getDataForUpdate(tableData)
    dispatch(updateData(form.values, dataForUpdate))
  }

  const contextValue = {
    form,
    initialValues,
    tableData,
    setTableData,
    selectedRow,
    setSelectedRow,
    editParams,
    setEditParams,
    editRow,
    deleteRow,
    saveData,
    buttonsBlockRef,
    titleEdit,
    createRow,
    tableAreaRef,
    from,
    editingRow,
    startEditingRow,
    confirmNewRow,
    cancelNewRow,
    updateEditingRow,
  }

  return (
    <DisciplineStructureContext.Provider value={contextValue}>
      <div className={styles.wrapper}>
        <h1>Структура учебного предмета</h1>
        <Form />
        <Table />
        <Footer />
      </div>
    </DisciplineStructureContext.Provider>
  )
}
